import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import "./SupportPlanModal.css";
import {
  getSencoReportByStudentId,
  upsertSencoReport,
} from "../services/APIClient";

const supportOptions = [
  { text: "Reading", color: "purple" },
  { text: "Writing", color: "purple" },
  { text: "Spelling", color: "purple" },
  { text: "Oral Language", color: "purple" },
  { text: "Numeracy", color: "purple" },
  { text: "Social Skills", color: "purple" },
  { text: "Attention and Concentration", color: "purple" },
  { text: "Fluency and Decoding", color: "purple" },
];

const PriorityConcernsModal = ({
  show,
  handleClose,
  studentName,
  // priorityConcerns,
  // setPriorityConcerns,
  // handleSaveChanges,
  currentStudentId,
  teacherid,
  callClassName,
  setName,
}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [priorityConcerns, setPriorityConcerns] = useState([]);

  useEffect(() => {
    if (show && currentStudentId) {
      getSencoReportByStudentId(currentStudentId)
        .then((response) => {
          if (response && response.priorityconcerns !== undefined) {
            setPriorityConcerns(response.priorityconcerns);
            setSelectedOptions(response.priorityconcerns || []); // Pre-select the options if available
          } else {
            setPriorityConcerns([]);
            setSelectedOptions([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching literacy observations:", error);
          setPriorityConcerns([]);
          setSelectedOptions([]);
        });
    }
  }, [show, currentStudentId, setPriorityConcerns]);

  const handleOptionClick = (text) => {
    const updatedOptions = selectedOptions.includes(text)
      ? selectedOptions.filter((option) => option !== text)
      : [...selectedOptions, text];
    setSelectedOptions(updatedOptions);
    setPriorityConcerns(updatedOptions);
    console.log(`Selected options for ${studentName}:`, updatedOptions);
  };

  const saveChanges = () => {
    handleSaveChanges();
    handleClose();
  };

  const handleModalClose = () => {
    setSelectedOptions([]); // Reset selected options to an empty array
    handleClose();
  };

  const handleSaveChanges = () => {
    const reportData = {
      studentid: currentStudentId,
      teacherid: teacherid,
      priorityconcerns: priorityConcerns,
      setname: setName,
      classname: callClassName,
    };

    console.log("Saving report data:", reportData);

    if (currentStudentId) {
      // setLastSavedStudentId(currentStudentId); // Update last saved student ID
      // resetStateVariables();
      upsertSencoReport(reportData)
        .then((response) => {
          // Reset only if saving for a different student
          console.log("Upsert JISI Report Success:", response);
        })
        .catch((error) => console.error("Error:", error));
    } else {
      console.error("Error: No student selected.");
    }
  };

  return (
    <Modal show={show} onHide={handleModalClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title style={{ textAlign: "center", width: "100%" }}>
          Priority Concerns
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="options-container">
          {supportOptions.map((option) => (
            <div
              key={option.text}
              className={`option ${option.color} ${
                (selectedOptions || []).includes(option.text) ? "selected" : ""
              }`}
              onClick={() => handleOptionClick(option.text)}
            >
              {option.text}
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="modal-button no-button" onClick={handleModalClose}>
          Cancel
        </button>
        <button className="modal-button yes-button" onClick={saveChanges}>
          Confirm
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default PriorityConcernsModal;
